import script from "./OrderDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderDetail.vue?vue&type=script&setup=true&lang=js"

import "./OrderDetail.vue?vue&type=style&index=0&id=5511fefc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5511fefc"]])

export default __exports__